import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="sobre-nosotros" className="about">
      <div className="container">
        <div className="about-header">
          <h2 className="section-title">Sobre Nosotros</h2>
          <div className="title-underline"></div>
        </div>

        <div className="about-content">
          <div className="about-text">
            <h3>Bienvenido a KAWILA HOSTEL & COFFEE</h3>
            <p>
              Ubicados en el corazón de Santa Ana, El Salvador, KAWILA es más que un hostal:
              es una experiencia única que combina historia, confort y hospitalidad.
            </p>
            <p>
              Nuestra propiedad colonial, con más de un año y medio de trayectoria, cuenta con
              detalles arquitectónicos de la década de los 80 y elementos góticos que te
              transportarán a otra época. Cada rincón de nuestra casa ha sido cuidadosamente
              diseñado con hermosos detalles de madera y puertas artesanales talladas a mano.
            </p>
            <p>
              En KAWILA, creemos que viajar es sentirse como en casa. Por eso, nos esforzamos
              en crear un ambiente acogedor donde nuestros huéspedes puedan relajarse, conocer
              nuevas personas y vivir experiencias inolvidables.
            </p>
          </div>

          <div className="about-features-grid">
            <div className="about-feature-card">
              <div className="feature-icon-large">🏛️</div>
              <h4>Arquitectura Colonial</h4>
              <p>Una propiedad histórica con detalles góticos y arquitectura de los años 80</p>
            </div>

            <div className="about-feature-card">
              <div className="feature-icon-large">🪵</div>
              <h4>Detalles Artesanales</h4>
              <p>Puertas de madera diseñadas a mano y elementos únicos en cada espacio</p>
            </div>

            <div className="about-feature-card">
              <div className="feature-icon-large">🏠</div>
              <h4>Como en Casa</h4>
              <p>Ambiente acogedor que te hace sentir la calidez del hogar</p>
            </div>

            <div className="about-feature-card">
              <div className="feature-icon-large">✨</div>
              <h4>Limpieza y Confort</h4>
              <p>Habitaciones confortables y espacios impecablemente limpios</p>
            </div>
          </div>
        </div>

        <div className="about-stats">
          <div className="stat-item">
            <h3>1.5+</h3>
            <p>Años de Experiencia</p>
          </div>
          <div className="stat-item">
            <h3>20</h3>
            <p>Habitaciones</p>
          </div>
          <div className="stat-item">
            <h3>100%</h3>
            <p>Hospitalidad</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
